<template>
  <svg
    id="contour_copia"
    data-name="contour copia"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <title>76_home-LIGHT</title>
    <path
      fill="#679940"
      class="cls-1"
      d="M63.41,32.41l-7.58-7.58h0l-21-21h0L33.41,2.41a2,2,0,0,0-2.82,0L29.17,3.83h0l-21,21h0L.59,32.41A2,2,0,0,0,0,33.83v.34a2,2,0,0,0,3.41,1.42L7,32V58a4,4,0,0,0,4,4H21a4,4,0,0,0,4-4V45a4,4,0,0,1,4-4h6a4,4,0,0,1,4,4V58a4,4,0,0,0,4,4H53a4,4,0,0,0,4-4V32l3.59,3.59A2,2,0,0,0,64,34.17v-.34A2,2,0,0,0,63.41,32.41ZM53,58H43V45a8,8,0,0,0-8-8H29a8,8,0,0,0-8,8V58H11V28L32,7,53,28Z"
    />
  </svg>
</template>

<script>
export default {
  name: "HomeIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/HomeIcon.vue